import { render, staticRenderFns } from "./DisplayReviews.vue?vue&type=template&id=5adf8af2&"
import script from "./DisplayReviews.vue?vue&type=script&lang=js&"
export * from "./DisplayReviews.vue?vue&type=script&lang=js&"
import style0 from "./DisplayReviews.vue?vue&type=style&index=0&id=5adf8af2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports